import * as React from "react";

interface CaretRightIconProps {
    className?: string;
    onClick?: () => void;
}

export class CaretRightIcon extends React.Component<CaretRightIconProps> {
    render() {
        return (
            <div {...this.props} data-testid="caretRight-icon">
                <svg width="10" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
                    <g id="CaretRight_Filled">
                        <path id="Vector" d="M17.0306 12.5312L9.53063 20.0312C9.42573 20.1362 9.29204 20.2077 9.14648 20.2367C9.00092 20.2657 8.85002 20.2509 8.71291 20.1941C8.57579 20.1372 8.45861 20.041 8.37621 19.9176C8.29381 19.7941 8.24988 19.649 8.25 19.5006V4.50059C8.24988 4.35217 8.29381 4.20705 8.37621 4.0836C8.45861 3.96016 8.57579 3.86394 8.71291 3.80712C8.85002 3.75031 9.00092 3.73546 9.14648 3.76444C9.29204 3.79343 9.42573 3.86496 9.53063 3.96997L17.0306 11.47C17.1004 11.5396 17.1557 11.6223 17.1934 11.7134C17.2312 11.8044 17.2506 11.902 17.2506 12.0006C17.2506 12.0992 17.2312 12.1967 17.1934 12.2878C17.1557 12.3788 17.1004 12.4616 17.0306 12.5312Z" fill="#973794" />
                    </g>
                </svg>
            </div>
        );
    }
}
